import { Injectable, InjectionToken, PLATFORM_ID, Renderer2, inject, DOCUMENT } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as themeActions from '../actions/themes.action';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { ThemesService } from '../../services';
import { Platform } from '@angular/cdk/platform';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ColorTranslator, Harmony, Mix } from 'colortranslator';

@Injectable()
export class ThemesEffects {
  private actions$ = inject(Actions);
  private themeService = inject(ThemesService);
  private document = inject(DOCUMENT);
  private platformId = inject<InjectionToken<Object>>(PLATFORM_ID);

  LoadThemes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(themeActions.LoadThemes),
      switchMap(() =>
        this.themeService.getThemes().pipe(
          map(themes => themeActions.LoadThemesSuccess({ themes })),
          catchError(error => of(themeActions.LoadThemesFail({ error })))
        )
      )
    );
  });

  LoadThemesSuccess$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(themeActions.LoadThemesSuccess),
        tap(({ themes }) => {
          if (isPlatformServer(this.platformId)) {
            return;
          }
          const cssRules = themes
            .map(theme => {
              const rules = Object.entries(theme).map(([key, value]) => {
                if (key === 'name') return '';
                if (key === 'id') return '';
                if (!value) return;
                const name = `--bs-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
                const nameH = `${name}-h`;
                const nameS = `${name}-s`;
                const nameL = `${name}-l`;
                const color = new ColorTranslator(value);

                //console.log(`Theme color for ${key} (${name}):`, color);

                return `${name}: ${color.HSL}; ${nameH}:${color.H}; ${nameS}: ${color.S}%; ${nameL}: ${color.L}%;`;
              });

              return `.${theme.name} {
              ${rules.join('\n    ')}
            }`;
            })
            .join('\n');

          const styleElement = this.document.createElement('style');
          // this.renderer.addClass(styleElement, 'theme-styles');
          styleElement.appendChild(this.document.createTextNode(cssRules));
          this.document.head.appendChild(styleElement);
        })
      );
    },
    { dispatch: false }
  );
}
